import React, { FC } from 'react';
import { Link as LinkCore } from 'ia-react-core';
import { Document } from '../../../../../../../../../interfaces/Document';
import { StyledListItem, StyledLink } from '../Links.styles';
import getLinkText from '../getLinkText';
import getPublicApiRoot from '../../../../../../../../../utils/getPublicApiRoot';

export interface LinkProps {
  document: Document;
}

const Link: FC<LinkProps> = ({ document, ...props }) => {
  const documentPath = `${getPublicApiRoot()}/content/secure?fileToken=${document.fileToken}`;
  return (
    <StyledListItem>
      <StyledLink>
        <LinkCore href={documentPath} target="_blank" {...props}>{getLinkText(document.name)}</LinkCore>
      </StyledLink>
    </StyledListItem>
  );
};
export default Link;
